import React from 'react';

// Change package.json, too.
function Version() {
    return <p className="text-end">ver. 1.2.7</p>;
}

export default Version;